var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgEmiratesId = function SvgEmiratesId(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8E1538",
    d: "M32 43c9.082 0 16.779 6.337 17.99 14.86a1 1 0 0 1-1.98.28C46.942 50.628 40.107 45 32 45c-8.107 0-14.942 5.627-16.01 13.14a1 1 0 0 1-1.98-.28C15.22 49.336 22.918 43 32 43zm0-21c5.525 0 10 4.475 10 10s-4.475 10-10 10-10-4.475-10-10 4.475-10 10-10zm0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3A3A",
    fillRule: "nonzero",
    d: "M31.996 0a6.995 6.995 0 0 1 6.995 6.865c.006.044.009.088.009.133V8h11.82c2.786 0 5.06 2.186 5.175 4.933l.005.218V58.85C56 61.695 53.682 64 50.82 64H13.18C10.32 64 8 61.698 8 58.849V13.15C8 10.305 10.318 8 13.18 8H25V6.998A6.996 6.996 0 0 1 31.756.004zM39 14.998A3.001 3.001 0 0 1 35.999 18H28A3.001 3.001 0 0 1 25 14.998V10H13.18c-1.7 0-3.082 1.317-3.175 2.973L10 13.15V58.85C10 60.589 11.422 62 13.18 62h37.64c1.76 0 3.18-1.412 3.18-3.151V13.15C54 11.411 52.578 10 50.82 10H39zM31.996 2A4.996 4.996 0 0 0 27 6.998v8c0 .553.447 1.002 1.001 1.002H36C36.55 16 37 15.552 37 14.998V7.121a1.01 1.01 0 0 1-.007-.123A4.996 4.996 0 0 0 31.996 2z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmiratesId, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emirates-id.319c017c.svg";
export { ForwardRef as ReactComponent };